module.exports = __webpack_public_path__ + "img/btn-invite.fb13b669.png";